import React from "react";
import { useTranslation } from "../../shared/translation/Translation";
import WarningPrompt from "./WarningPrompt";

const CustomerJoinsTheLobbyPrompt: React.FC = () => {
    const messages = useTranslation();

    return <WarningPrompt message={messages.customerJoinsLobbyPrompt.content}></WarningPrompt>;
};

export default CustomerJoinsTheLobbyPrompt;
